module.exports = __webpack_public_path__ + "img/main_bg_image.8bf87527.png";